import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks when the user clicks an integration card to open the details modal',
  name: 'integration_card_clicked',
  params: [
    {
      description: 'The ID of the integration',
      name: 'integration_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The name of the integration',
      name: 'integration_name',
      required: true,
      type: 'string',
    },
    {
      description: 'The section the integration belongs to',
      name: 'integration_section',
      required: true,
      type: 'string',
    },
    {
      description: 'The current status of the integration',
      name: 'integration_status',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
